export const sentryEnvironment = {
	release: '3409c2593cce844d46aa47396c54cd2a2d52f9cf',
};
